import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API });

export const api = {
  listSessions: () => http.get("/sessions").then((r) => r.data),
  getActive: () => http.get("/sessions/active").then((r) => r.data),
  getSession: (id) => http.get(`/sessions/${id}`).then((r) => r.data),
  createSession: (payload) =>
    http.post("/sessions", payload).then((r) => r.data),
  updateSession: (id, payload) =>
    http.patch(`/sessions/${id}`, payload).then((r) => r.data),
  deleteSession: (id) => http.delete(`/sessions/${id}`).then((r) => r.data),

  listCrumbs: (id) =>
    http.get(`/sessions/${id}/breadcrumbs`).then((r) => r.data),
  addCrumb: (id, payload) =>
    http.post(`/sessions/${id}/breadcrumbs`, payload).then((r) => r.data),

  interrupt: (id, payload) =>
    http.post(`/sessions/${id}/interrupt`, payload).then((r) => r.data),

  transcribe: (id, blob) => {
    const form = new FormData();
    const fname = `voice-${Date.now()}.webm`;
    form.append("file", blob, fname);
    return http
      .post(`/sessions/${id}/transcribe`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data);
  },

  resumeSummary: (id) =>
    http.post(`/sessions/${id}/resume-summary`).then((r) => r.data),

  praise: (id, momentum = 0) =>
    http
      .post(`/sessions/${id}/praise`, { momentum })
      .then((r) => r.data),

  stats: () => http.get("/stats").then((r) => r.data),
};
